
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetTemData, PatchCepingSort } from "@/request/common";
import { GetIdArr } from "@/utils/base";
@Component({})
export default class Name extends Vue {
  @Prop()
  private visible: any;
  @Watch("visible", { immediate: true })
  private visibleChange() {
    this.ifShow = this.visible;
    if (this.visible) {
      this.getList();
    }
  }
  private ifShow: any = false;
  private data: any = [];
  private defaultProps: any = {
    children: "children",
    label: "template_id",
  };
  private cancel() {
    this.$emit("cancel");
  }
  private save() {
    const arr: any = GetIdArr(this.data);
    // return;
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      keys: arr,
    };
    PatchCepingSort(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("保存成功");
        this.$emit("change");
      })
      .catch(() => {
        loading.close();
      });
  }
  private getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        as_assess: "True",
        sort_key: "sort_in_ceping",
      },
    };
    GetTemData(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
      })
      .catch(() => {
        loading.close();
      });
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (type == "inner") {
      return false;
    } else {
      return true;
    }
  }
}
